import { render, staticRenderFns } from "./dal-menu-on-main.vue?vue&type=template&id=6d7d5c75"
import script from "./dal-menu-on-main.vue?vue&type=script&lang=js"
export * from "./dal-menu-on-main.vue?vue&type=script&lang=js"
import style0 from "./dal-menu-on-main.vue?vue&type=style&index=0&id=6d7d5c75&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports